import { render, staticRenderFns } from "./PageWineUpdate.vue?vue&type=template&id=90c143e2"
import script from "./PageWineUpdate.vue?vue&type=script&lang=ts"
export * from "./PageWineUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports